const loading = state => state.loading;

export default { loading };
